import { useState } from "react";
// components
import { SwitchToggle } from "@gl-shared/shared/ui";
// icons
import { marketplacePlaceholderImg, promotedIcon } from "@gl-shared/shared/vector";
// helpers
import { isPromoted, getPriceTypeName } from "@gl-shared/shared/helpers";
import { getCommissionLabel } from "../../common/utils/panel-helpers/helpers";

const MarketplaceItem = ({ marketplace, onUpdateOffer }) => {
  // If a non-promoted offer is not enabled for a channel, then it should be greyed out AND deactivated (slider off)
  // This "!isPromoted() && !marketplace?.hotel_concierge_enabled" condition is additional check, in order if BE returns bad value...
  // By rule, if --enabled is false, then also --active needs to be false
  const [conciergeToggleValue, setConciergeToggleValue] = useState(
    !isPromoted() && !marketplace?.hotel_concierge_enabled ? false : marketplace?.hotel_concierge_active
  );
  const [guestPlatformToggleValue, setGuestPlatformToggleValue] = useState(
    !isPromoted() && !marketplace?.guest_platform_enabled ? false : marketplace?.guest_platform_active
  );
  const [kioskToggleValue, setKioskToggleValue] = useState(
    !isPromoted() && !marketplace?.lobby_kiosk_enabled ? false : marketplace?.lobby_kiosk_active
  );
  // -- end

  const handleToggleButton = field => {
    switch (field) {
      case "concierge":
        setConciergeToggleValue(!conciergeToggleValue);
        onUpdateOffer(marketplace, field, !conciergeToggleValue);
        break;
      case "guestPlatform":
        setGuestPlatformToggleValue(!guestPlatformToggleValue);
        onUpdateOffer(marketplace, field, !guestPlatformToggleValue);
        break;
      case "kiosk":
        setKioskToggleValue(!kioskToggleValue);
        onUpdateOffer(marketplace, field, !kioskToggleValue);
        break;
      default:
        return null;
    }
  };

  return (
    <div className="marketplace__item-box">
      <div className="marketplace__item-box-image">
        <img src={marketplace?.image || marketplacePlaceholderImg} alt="offer-image" />
      </div>
      <div className="marketplace__item-box-section first-section">
        <div className="marketplace__item-box-text-light">{marketplace?.provider_short_name?.toUpperCase()}</div>
        <div className="marketplace__item-box-text-dark">{marketplace?.name}</div>
      </div>
      <div className="marketplace__item-box-section borderSeparator">
        <div className="marketplace__item-box-text-light">
          {marketplace?.currency} {marketplace?.price} <span>{getPriceTypeName(marketplace?.price_type)}</span>
        </div>
        <div className="marketplace__item-box-text-light">
          {getCommissionLabel(
            marketplace?.commission,
            marketplace?.commission_type,
            marketplace?.currency,
            getPriceTypeName(marketplace?.price_type)
          )}
        </div>
      </div>
      <div className="marketplace__item-box-section">
        {isPromoted(marketplace?.promoted) && (
          <img src={promotedIcon} className="marketplace__promoted-icon" alt="Promoted" />
        )}
        <div className="marketplace__item-box__toggler-wrapper">
          <div
            className={`marketplace__item-box__toggler-section ${
              !marketplace?.hotel_concierge_enabled || isPromoted(marketplace?.promoted)
                ? "toggler-section-disabled"
                : ""
            }`}
          >
            <span>Concierge</span>
            <SwitchToggle
              checked={conciergeToggleValue}
              value={conciergeToggleValue}
              onChange={() => handleToggleButton("concierge")}
            />
          </div>
          <div
            className={`marketplace__item-box__toggler-section ${
              !marketplace?.guest_platform_enabled || isPromoted(marketplace?.promoted)
                ? "toggler-section-disabled"
                : ""
            }`}
          >
            <span>Guest Platform</span>
            <SwitchToggle
              checked={guestPlatformToggleValue}
              value={guestPlatformToggleValue}
              onChange={() => handleToggleButton("guestPlatform")}
            />
          </div>
          <div
            className={`marketplace__item-box__toggler-section ${
              !marketplace?.lobby_kiosk_enabled || isPromoted(marketplace?.promoted) ? "toggler-section-disabled" : ""
            }`}
          >
            <span>Kiosk</span>
            <SwitchToggle
              checked={kioskToggleValue}
              value={kioskToggleValue}
              onChange={() => handleToggleButton("kiosk")}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default MarketplaceItem;
